import type { AskNexusConversationSummary } from "@/features/ask-nexus/api/ask-nexus.api";

export type HistoryGroupId = "running" | "today" | "yesterday" | "lastWeek" | "older";

export interface HistoryGroup {
  id: HistoryGroupId;
  items: AskNexusConversationSummary[];
}

const DAY_MS = 24 * 60 * 60 * 1000;
const GROUP_ORDER: HistoryGroupId[] = ["running", "today", "yesterday", "lastWeek", "older"];

/** Running first, then by the last activity's calendar day in the viewer's time zone. */
export function groupHistory(items: AskNexusConversationSummary[], now: Date, query = ""): HistoryGroup[] {
  const needle = query.trim().toLowerCase();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const buckets = new Map<HistoryGroupId, AskNexusConversationSummary[]>();

  for (const item of items) {
    if (needle && !item.title.toLowerCase().includes(needle)) continue;
    const group = groupFor(item, startOfToday);
    buckets.set(group, [...(buckets.get(group) ?? []), item]);
  }

  return GROUP_ORDER.flatMap((id) => {
    const groupItems = buckets.get(id);
    return groupItems?.length ? [{ id, items: groupItems }] : [];
  });
}

function groupFor(item: AskNexusConversationSummary, startOfToday: number): HistoryGroupId {
  if (item.status === "running") return "running";
  const updated = Date.parse(item.updatedAt);
  if (updated >= startOfToday) return "today";
  if (updated >= startOfToday - DAY_MS) return "yesterday";
  if (updated >= startOfToday - 7 * DAY_MS) return "lastWeek";
  return "older";
}
